import Vue from 'vue'
import Router from 'vue-router'
import choose from "../components/routerPages/choose";
import storeMap from "../components/routerPages/storeMap";
import error from "../components/routerPages/error"
import init from "../components/routerPages/init";
import orderv2 from "../components/routerPages/orderv2";
import orderv3 from "../components/routerPages/orderv3";
import bill from "../components/routerPages/bill";
import takeoutordered from "../components/ordered/takeoutOrdered"
import pay from "../components/routerPages/pay/pay";

Vue.use(Router)
export default new Router({
  routes: [
    {path: "*", redirect: "/error"},
    {path: '', redirect: '/choose/21cad17f3c25444fa64e91b664551fc5'},
    {name:'choose', path: '/choose/:sellerId', component:choose},
    {name:'t', path: '/t', component:takeoutordered},
    {name:'error', path: '/error', component: error,},
    {name:'storemap', path: '/storemap/:sellerId/:storeId/:city/:address/:distance/:name', component:storeMap},
    {name:'init', path: '/order/:sellerId/:storeId/:orderType/:isCheckNetBill', component:init},
    {name:'orderv2', path: '/orderv2/:sellerId/:storeId/:orderType/:tableNo', component:orderv2},
    {name:'orderv3', path: '/orderv3/:sellerId/:storeId/:orderType/:tableNo', component:orderv3},
    {name:'bill', path: '/bill/:sellerId', component:bill},
    {name:'pay', path: '/pay', component:pay},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js